<template>
  <w-setting-sliding-popup ref="slidingPopup"  title="도메인 추가" width="400px" @close="close">
    <div slot="content">
      <el-form ref="domainForm" :rules="rules" :model="domainFormData">
        <el-row>
          <el-form-item prop="netIpaddress" label="IP 주소">
            <el-input placeholder="Ipv4 혹은 Ipv6를 입력해주세요" clearable v-model="domainFormData.netIpaddress"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item prop="domainName" label="도메인 이름">
            <el-input clearable v-model="domainFormData.domainName"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item prop="aliasName" label="사용자 정의">
            <el-input clearable v-model="domainFormData.aliasName"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button size="large" type="solid" @click="clickSaveButton">저장</el-button>
      <el-button size="large" @click="clickClose">취소</el-button>
    </div>
  </w-setting-sliding-popup>
</template>

<script>
import { isEmpty } from '@/utils/basic';
import { validateIpv4, validateIpv6 } from '@/utils/string';
import msgUtil from '@/utils/message';
import OperationSettingsAPI from '@/api/settings/common/operation-settings';

export default {
  name: 'WAddDomainSlidingPopup',
  data() {
    return {
      domainFormData: {
        netIpaddress: null,
        domainName: null,
        aliasName: null,
      },
      rules: {
        netIpaddress: [{ required: true, trigger: 'blur', validator: this.validatePassForIp }],
        domainName: [{ required: true, trigger: 'blur', message: '도메인 이름을 입력해주세요' }],
      },
      saveButtonFlag: true,
    };
  },
  methods: {
    open() {
      this.$refs.slidingPopup.open();
      this.$nextTick(() => {
        this.$refs.domainForm.resetFields();
      });
    },
    close() {
      this.domainFormData = {
        netIpaddress: null,
        domainName: null,
        aliasName: null,
      };
    },
    clickClose() {
      this.$refs.slidingPopup.close();
    },
    // 도메인 ip를 추가한다.
    clickSaveButton() {
      this.$refs.domainForm.validate().then((response) => {
        if (response) {
          const params = this.domainFormData;
          // api 요청
          OperationSettingsAPI.addNetIpDomainName(params).then((responseData) => {
            if (responseData.data.success) {
              this.$emit('load-data');
              this.clickClose();
            }
            this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '도메인', response.data.success));
          });
        }
      }).catch(() => {
      });
    },
    // IPv4, IPv6에 대한 정규식 유효성 검사
    validatePassForIp(rule, value, callback) {
      if (isEmpty(value)) {
        callback(new Error('값을 입력해주세요'));
      } else if (!validateIpv4(value) && !validateIpv6(value)) {
        callback(new Error('올바른 IPv4 혹은 IPv6 주소형식을 입력해주세요'));
      } else {
        OperationSettingsAPI.isExistDomain({ netIpaddress: value }).then((response) => {
          if (response.data.success && response.data.data) {
            callback();
          } else {
            callback(new Error('이미 존재하는 IP주소입니다.'));
          }
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/DomainServicePort/popup/AddDomainSlidingPopup.vue